import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HotGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              本周必看韩漫精选
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            根据阅读量和用户评分精选推荐，汇集各类题材中口碑与人气双高的优秀作品。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {featuredComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className={`group rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                index === 1
                  ? 'bg-secondary-500'
                  : 'bg-background-100'
              }`}
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-medium">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  <span>{comic.rating}</span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                    comic.status === '连载中'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-foreground-600 text-background-50'
                  }`}>
                    {comic.status}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium mb-2 ${
                  index === 1
                    ? 'bg-background-50/20 text-background-50'
                    : 'bg-accent-100 text-accent-800'
                }`}>
                  {comic.category === 'romance' ? '恋爱' :
                   comic.category === 'action' ? '动作' :
                   comic.category === 'fantasy' ? '奇幻' : comic.category}
                </span>

                <h3 className={`font-heading text-lg font-bold mb-1.5 line-clamp-1 ${
                  index === 1 ? 'text-background-50' : 'text-foreground-950'
                }`}>
                  {comic.title}
                </h3>

                <p className={`text-sm leading-relaxed line-clamp-2 mb-3 ${
                  index === 1 ? 'text-background-100/90' : 'text-foreground-600'
                }`}>
                  {comic.description}
                </p>

                <div className={`flex items-center gap-4 text-xs ${
                  index === 1 ? 'text-background-200/80' : 'text-foreground-500'
                }`}>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {comic.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-file-list-3-line"></i>
                    {comic.chapters}话
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {comic.author}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}